import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Factura } from 'src/app/Models/factura/factura';
import { DataService } from 'src/app/Service/data.service';
import { AlertComponent } from '../../objects/alert/alert/alert.component';
import { InfoComponent } from '../../objects/info/info/info.component';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { Router } from '@angular/router';
import { ALertOption } from 'src/app/Models/alert/alert-option';
import { Filtro } from 'src/app/Models/filtro/filtro';
import { AuthService } from 'src/app/Service/auth.service';
import * as moment from 'moment';
import { AnularFacturaComponent } from '../../facturacion/anular-factura/anular-factura.component';
import { PrintPedidoComponent } from '../../print/print-pedido/print-pedido.component';

@Component({
  selector: 'app-pedido-dialog',
  templateUrl: './pedido-dialog.component.html',
  styleUrls: ['./pedido-dialog.component.css']
})
export class PedidoDialogComponent implements OnInit {
  @ViewChild('btnshow', null) btnshow: ElementRef;
  @ViewChild('btnclose', null) btnclose: ElementRef;
  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;

  @ViewChild(AnularFacturaComponent, null) frmAnulacion: AnularFacturaComponent;

      @ViewChild(PrintPedidoComponent, null) print_pedido: PrintPedidoComponent;
  public isShow: boolean = false;
  public pagina: number = 0;
  public pedidos: Factura[] = [];
  public pedido: Factura = new Factura();
  public isEdit: boolean = false;
  public funcion: Function = null;
  public pagpddg: any;
  public search = '';
  public modal = "";
  public showdelete: boolean = false;
  public zindex: number = 10000;
  public usuario = null;
  public cantidad: number = 0;
  public isclosed: Boolean = false;
  public options: ALertOption = new ALertOption()
  public filtro: Filtro = new Filtro()
  public titulo: string = 'Pedidos Pendientes';
  public datadia: boolean;
  constructor(private data: DataService, private route: Router, private auth: AuthService) { }

  ngOnInit() {
  }

  public show(affterfunction: Function = null) {
    this.isclosed = false;
    this.funcion = affterfunction;
    this.isShow = true;
    this.showTab(1);
    this.showdelete = false;
    setTimeout(() => {
      this.btnshow.nativeElement.click();
      this.usuario = this.auth.getCurrentUser();
      this.options.showCancelButton = true
      this.info.hide();

      this.pedidos = []
      console.log(this.datadia);

      this.GetData();
    }, 10);
  }


  GetData() {
    if (this.usuario.idpersonal.idnivel != 2) {
      if (this.datadia) {
        console.log("mostrando por dia");

        this.GetAdminDataporDia()
      } else {
        console.log("mostrando pendientes");

        this.GetAdminData()
      }
    } else { this.GetVendedorData() }

  }

  async GetAdminData() {
    //this.filtro.idvende=this.usuario.idpersonal.idpersonal
    const filtro: Filtro = {
      fecha: moment(new Date()).format('YYYY-MM-DD'),
      entrega: '0',
      idvende: this.usuario.idpersonal.idnivel == 1 ? null : this.usuario.idpersonal.idpersonal,
      idsucursal: this.data.getSucursalId(),
      incluir_detalles: true
    }

    await this.data.AsyncPost('filtrardoc/Factura', filtro).then(r => {
      console.log(r);

      if (r.status = 'success') {
        const dataFiltrada = r.data.filter((item: any) => item.estado !== 'ANU');
        if (dataFiltrada) {
          this.pedidos = dataFiltrada;
        }else{
          this.pedidos = [];
        }

      } else { this.pedidos = []; }

    }).catch(e => { console.log(e) });

  }

  async GetAdminDataporDia() {
    //this.filtro.idvende=this.usuario.idpersonal.idpersonal
    const filtro: Filtro = { fecha: moment(new Date()).format('YYYY-MM-DD') }

    await this.data.AsyncPost('filtrardoc/Factura', filtro).then(r => {
      console.log(r);

      if (r.status = 'success') {
        this.pedidos = r.data;
      } else { this.pedidos = []; }

    }).catch(e => { console.log(e) });

  }


  async GetVendedorData() {
    this.filtro.idvende = this.usuario.idpersonal.idpersonal
    this.filtro.entrega = '0'
    this.filtro.estado = 'CAN'

    const filtro: Filtro = {
      idvende: this.usuario.idpersonal.idpersonal,
      entrega: '0',
      incluir_detalles: true
    }
    await this.data.AsyncPost('filtrardoc/Factura', filtro).then(r => {
      console.log(r);

      if (r.status = 'success') {
        const dataFiltrada = r.data.filter((item: any) => item.estado !== 'ANU');
        if (dataFiltrada) {
          this.pedidos = dataFiltrada;
        }else{
          this.pedidos = [];
        }

      } else { this.pedidos = []; }

    }).catch(e => { console.log(e) });

  }

  showTab(i) {
    this.pagina = i;
    if (this.pagina == 1) { this.modal = 'modal-lg'; }
    else { this.modal = ''; }
  }
  selected(idpedido) {
    console.log("Mostrando id",idpedido);

    try {
      this.print_pedido.facturaId = idpedido;
      this.print_pedido.getEmpresa()
      this.print_pedido.getFactura(); // Espera a que termine
      setTimeout(() => {
        this.print_pedido.generarTicket(); // Ahora sí ejecuta
      }, 500);
    } catch (error) {
      console.error("Error en el flujo:", error);
    }
  }

  entregado(pedido) {
    this.pedido = pedido
    this.close()
    // this.data.notify("Desea confirmar la entrega del pedido", "Atencion", this.data.alertType.question, this.options, () => {
    //   pedido.entrega = 1
    //   this.data.Put(this.data.api.factura, pedido.idfactura, pedido).subscribe((data) => {
    //     console.log(data)
    //     this.GetData()
    //   }, (error) => { console.log(error) })
    // }, () => { this.GetData() })

  }

  anulado(pedido) {
    this.frmAnulacion.factura = pedido
    this.frmAnulacion.show(() => {
      this.GetData()

    })

    // this.data.notify("Desea confirmar la anulacion del pedido", "Atencion", this.data.alertType.question, this.options, () => {
    //   pedido.entrega = 1
    //   this.data.Put(this.data.api.factura, pedido.idfactura, pedido).subscribe((data) => {
    //     console.log(data)
    //     this.GetData()
    //   }, (error) => { console.log(error) })
    // }, () => { this.GetData() })

  }

  entregarPedido() {

  }

  redirect(enlaceGoogleMaps: string) {
    if (enlaceGoogleMaps) {
      window.open(enlaceGoogleMaps, '_blank');
    } else {
      console.error('No hay enlace de Google Maps disponible');
    }
  }



  select(i: any) {
    this.pedido = this.pedidos[i];
    console.log(this.pedido);
    this.isclosed = true;
    this.btnclose.nativeElement.click();

  }
  close() {
    if (!this.isclosed) {
        this.isclosed = true;
        this.btnclose.nativeElement.click();
    }
    setTimeout(() => {
        this.isShow = false;
        // Ejecutar el callback DESPUÉS de cerrar completamente
        if (this.funcion != null) {
            this.funcion();
        }
    }, 250); // Aumenté el tiempo a 250ms para asegurar que termine la animación
}
}

